import { TextInput as CarbonTextInput } from '@carbon/react';
import type { ComponentProps } from 'react';

export type CdTextInputProps = ComponentProps<typeof CarbonTextInput>;

export const CdTextInput = (props: CdTextInputProps) => {
  return <CarbonTextInput {...props} />;
};
